/** @jsx jsx */
import { jsx } from "theme-ui";

export const Profile = ({ name, body, picture }) => {
  return <div />;
};
